module.exports = __webpack_public_path__ + "static/media/Hyaluron_Collagen_komplex_kapky_retina_2.5ce53485.jpg";